import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfigWebsitPouyan";

export const actionTypes = {
  getAllTags: "[getAllTags] Action",
  getAllTagsLoading: "[getAllTagsLoading] Action",
  getAllTagsAsync: "[getAllTagsAsync] Action",
};

const initialState = {
  data: [],
  size: 20,
  total: 10000,
  loading: false,
};

export const get_all_tags_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.getAllTags:
      return {
        ...state,
        data: payload.results,
        total: payload.total ? payload.total : state.total,
      };
    case actionTypes.getAllTagsLoading:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};


function* handleWorker({ payload }) {
  let config = {
    url: `Tags/GetTagsWithNews`,
    method: "GET"
  };

  if (payload.query) {
    const urlParams = new URLSearchParams();
    Object.keys(payload.query).forEach(key => {
      if (payload.query[key] !== null && payload.query[key] !== undefined) {
        urlParams.append(key, payload.query[key]);
      }
    });
    if (urlParams.toString()) {
      config.url += `?${urlParams.toString()}`;
    }
  }

  let data = {
    ...payload?.data
  };

  yield put({
    type: actionTypes.getAllTagsLoading,
    payload: true,
  });

  try {
    let res = yield AxiosCustom(config, data);

    yield put({
      type: actionTypes.getAllTags,
      payload: {
        results: res?.data?.data?.news ? res?.data?.data?.news : res?.data?.data,
        total: res?.data?.data?.totalCount ? res?.data?.data?.totalCount : res?.data?.data?.length,
        size: res?.data?.data?.size,
      },
    });
    yield put({
      type: actionTypes.getAllTagsLoading,
      payload: false,
    });
  } catch {
    yield put({
      type: actionTypes.getAllTagsLoading,
      payload: false,
    });
  }
}

export function* get_all_tags_worker() {
  yield takeLatest(actionTypes.getAllTagsAsync, handleWorker);
}
